import AdManagementSettingsReducer from 'store/ad-management-settings/reducers';

export default AdManagementSettingsReducer;
